import React, { useState } from 'react';
import api from '../http';

export default function StationPinVerify({ user, assignedStation, onVerify }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Authenticated but no assignment: this view is reached *after* successful
  // login, so "back to login" was misleading. Offer the actions that fit
  // their state — wait/refresh, or sign out and try a different account.
  if (!assignedStation) {
    const handleSignOut = async () => {
      try { await api.post('/api/proctor/logout'); } catch (e) { /* ignore */ }
      window.location.assign('/proctor/login');
    };

    return (
      <div className="proctor-pin-verify">
        <div className="verify-card">
          <h2>No Station Assigned</h2>
          <p>You have not been assigned to a station for this test event.</p>
          <p>Once Command assigns you to a station, this screen will update automatically.</p>
          <button onClick={() => window.location.reload()} className="primary-button">
            Check Again
          </button>
          <button onClick={handleSignOut} className="secondary-button">
            Sign Out
          </button>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await api.post('/api/proctor/verify-station', { pin });
      if (res.data.success) {
        onVerify(res.data); // onVerify in ProctorApp handles navigation to /proctor/queue
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid PIN');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="proctor-pin-verify">
      <div className="verify-card">
        <h1>📍 Station Verification</h1>
        <div className="station-info-box">
          <div className="label">Assigned Station</div>
          <div className="value">
            #{assignedStation.station_number} — {assignedStation.name}
          </div>
        </div>

        <p className="instruction">Enter the 4-digit PIN located at your physical station to begin.</p>

        <form onSubmit={handleSubmit}>
          <input
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="0000"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            maxLength="4"
            autoComplete="off"
            className="pin-input"
          />

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading || !pin} className="primary-button">
            {loading ? 'Verifying…' : 'Verify & Unlock'}
          </button>
        </form>
      </div>
    </div>
  );
}
